import type { FC } from 'react'
import classNames from 'classnames'
import type { AccordionTabProps } from './Accordion.types'
import AccordionTab from './components'

type AccordionProps = {
  tabInfo: Array<AccordionTabProps>
}

const Accordion: FC<AccordionProps> = ({ tabInfo }) => (
  <div
    data-testid="accordionId"
    className={classNames([
      'grid col-span-full gap-x-6',
      'lg:col-start-2 lg:col-span-10 lg:grid-cols-10',
      'xl:col-start-3 xl:col-span-8 xl:grid-cols-8',
    ])}
  >
    <hr className="col-span-full mt-8 sm:mt-4" />
    {tabInfo.map((tab) => (
      <AccordionTab {...tab} key={`accordion-tab-for-${tab.id}`} />
    ))}
  </div>
)

export default Accordion
